<template>
  <ToolbarItemContainer
    :iconFile="isH5 ? fileIconH5 : fileIcon"
    :title="props.title || TUITranslateService.t('文件')"
    iconWidth='20px'
    iconHeight='20px'
    :needDialog="false"
    @onIconClick="onIconClick"
  >
    <div :class="['file-upload', !isPC && 'file-upload-h5']">
      <input
        ref="inputRef"
        :title="props.title || TUITranslateService.t('文件')"
        type="file"
        data-type="file"
        accept="*"
        @change="sendFileMessage"
      >
    </div>
  </ToolbarItemContainer>
</template>
<script lang="ts">
import { TUIChatService, TUIStore, StoreName, IConversationModel, SendMessageParams, SendMessageOptions, TUITranslateService } from '../../../../@aidesk/uikit-engine';
import vue from '../../../../adapter-vue';
import ToolbarItemContainer from '../toolbar-item-container/index.vue';
import fileIcon from '../../../../assets/files.svg';
import fileIconH5 from '../../../../assets/file-h5.png';
import { isPC, isH5 } from '../../../../utils/env';
import { isEnabledMessageReadReceiptGlobal, getTo } from '../../../../utils/utils';
import Log from '../../../../utils/logger';
import { Toast, TOAST_TYPE } from '../../../common/Toast/index-web';
const __sfc_main = {};
__sfc_main.props = {
  title: {
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    ref
  } = vue;
  const props = __props;
  const inputRef = ref();
  const currentConversation = ref<IConversationModel>();
  TUIStore.watch(StoreName.CONV, {
    currentConversation: (conversation: IConversationModel) => {
      currentConversation.value = conversation;
    }
  });
  const onIconClick = () => {
    inputRef?.value?.click && inputRef?.value?.click();
  };
  const sendFileMessage = (e: any) => {
    if (e?.target?.files?.length <= 0) {
      return;
    }
    const file = e.target.files[0];
    if (!file || !file.size) {
      return;
    }
    const options = {
      to: getTo(currentConversation?.value),
      conversationType: currentConversation?.value?.type,
      payload: {
        file: e.target
      },
      needReadReceipt: isEnabledMessageReadReceiptGlobal()
    } as SendMessageParams;
    const sendMessageOptions: SendMessageOptions = {};
    TUIChatService.sendFileMessage(options, sendMessageOptions).catch(err => {
      Toast({
        message: err.code === 2402 ? TUITranslateService.t('AIDesk.file 大小超过 100MB，无法发送') : err.message,
        type: TOAST_TYPE.ERROR,
        duration: 5000
      });
      Log.l(`Send File Failed:${err.code} ${err.message}`);
    });
    e.target.value = '';
  };
  return {
    TUITranslateService,
    fileIcon,
    fileIconH5,
    isPC,
    isH5,
    props,
    inputRef,
    onIconClick,
    sendFileMessage
  };
};
__sfc_main.components = Object.assign({
  ToolbarItemContainer
}, __sfc_main.components);
export default __sfc_main;
</script>
<style lang="scss" scoped>
@import "../../style/common";
</style>
